import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type ChangedField = {
    field: string
    from: string | undefined
    to: string | undefined
}

export type LinkingChange = {
    type: 'added' | 'removed'
    field: string
    count: number
}

export type RoadmapChange = {
    _id: string
    contentId?: string // The ID of the actual VM/Evidence/Activity
    title: string
    type: string
    typeShort: string
    action: 'create' | 'update' | 'delete'
    timestamp: string
    createdAt: string
    user?: {
        name: string
        email: string
    } | null
    changedFields: ChangedField[]
    linkingChanges?: LinkingChange[]
    hasEmptyMetadata?: boolean // True if from/to were missing in Event
    from?: Record<string, unknown>
    to?: Record<string, unknown>
    data?: Record<string, unknown>
}

export type RoadmapChangesResponse = {
    success: boolean
    data: {
        changes: RoadmapChange[]
        total: number
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminRoadmapChangesQuery = (roadmapId: string, enabled: boolean = true, limit: number = 50) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getRoadmapChanges = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(`/api/admin/roadmaps/${roadmapId}/changes?limit=${limit}`, 'get', token)
            return response
        } catch (e) {
            console.error('Error fetching roadmap changes:', e)
            throw e
        }
    }

    return useQuery<RoadmapChangesResponse>(['admin', 'roadmap-changes', roadmapId, limit], getRoadmapChanges, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!roadmapId && enabled,
        cacheTime: FIVE_MINUTES,
        staleTime: 30000,
        retry: 2,
    })
}
